import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getPendingSubscribers,
  getActiveSubscribers,
} from "../../../../store/actions/newSubscriber";

import TableHeader from "./lib/TableHeader";
import { hideLoader, showLoader } from "../../../../store/actions";
import { getProfileData } from "../../../../store/actions/profile";
import CustomLoader from "../../../forms/Loader";
import SubscriberTable from "./lib/SubscriberTable";

const SubscriberList = () => {
  const [activeTab, setActiveTab] = useState("Active Subscribers");
  const [agentRefNumber, setAgentRefNumber] = useState("");
  const [pendingSubscribers, setpendingSubscribers] = useState([]);
  const [activeSubscribers, setactiveSubscribers] = useState([]);
  const dispatch = useDispatch();

  const token = useSelector((state) => state.authReducer.token);
  const userId = useSelector((state) => state.authReducer.userId);
  const displayLoader = useSelector((state) => state.loaderUtil.displayLoader);
  const { PAN } = useSelector((state) => state.profileReducer.profileData);

  useEffect(() => {
    const fetchDistributorDetails = async () => {
      try {
        dispatch(showLoader());
        await dispatch(
          getProfileData({
            Agent: token,
            UserId: userId,
          })
        );
      } catch (error) {
        console.trace(error);
      } finally {
        dispatch(hideLoader());
      }
    };

    if (PAN) return;

    fetchDistributorDetails();
  }, [dispatch, token, userId, PAN]);

  useEffect(() => {
    if (PAN) {
      const arn = token.replace("ARN-", "").padStart(8, 0);
      setAgentRefNumber(PAN + arn);
    }
  }, [PAN, token]);

  const fetchPendingSubscribers = async () => {
    try {
      dispatch(showLoader());
      const response = await dispatch(
        getPendingSubscribers({
          AgentReferenceNumber: agentRefNumber,
        })
      );
      setpendingSubscribers(response.data);
    } catch (error) {
      console.trace(error);
    } finally {
      dispatch(hideLoader());
    }
  };
  const fetchActiveSubscribers = async () => {
    try {
      dispatch(showLoader());
      const response = await dispatch(
        getActiveSubscribers({
          AgentReferenceNumber: agentRefNumber,
        })
      );
      setactiveSubscribers(response.data);
    } catch (error) {
      console.trace(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  useEffect(() => {
    if (!agentRefNumber) return;

    if (activeTab === "Pending Subscribers" && !pendingSubscribers.length) {
      fetchPendingSubscribers();
      return;
    }

    if (activeSubscribers.length) return;

    fetchActiveSubscribers();
  }, [agentRefNumber, activeTab]);

  const ActiveSubscribersTable = () => (
    <SubscriberTable active={"Active Subscribers"} data={activeSubscribers} />
  );

  const PendingSubscribersTable = () => (
    <SubscriberTable active={"Pending Subscribers"} data={pendingSubscribers} />
  );

  return (
    <div className="container-margin">
      <CustomLoader display={displayLoader} />
      <div style={{ fontSize: "20px", fontWeight: 400, marginBottom: "16px" }}>
        NPS Investors List
      </div>
      <div className="sub-table-container">
        <div className="sub-table-tab-container2">
          <div
            className="sub-table-tab-container"
            style={{ borderBottom: "0px" }}
          >
            <TableHeader
              value="Active Subscribers"
              active={activeTab === "Active Subscribers"}
              onClick={() => setActiveTab("Active Subscribers")}
            />
            <TableHeader
              value="Pending Subscribers"
              active={activeTab === "Pending Subscribers"}
              onClick={() => setActiveTab("Pending Subscribers")}
            />
          </div>
          <div style={{ paddingBottom: "6px" }}>
            {/* <button className="add-subscriber-button">Add Subscriber</button> */}
          </div>
        </div>
      </div>

      {activeTab === "Pending Subscribers" ? (
        <PendingSubscribersTable />
      ) : (
        <ActiveSubscribersTable />
      )}
    </div>
  );
};

export default SubscriberList;
